import React from "react";
import FormSelect from "../../../components/UI/formSelect/formSelect";
import { IPMBlock } from "../../../models/IPages";

const availableCalculators = [
  "Repayment Calculator",
  "Borrowing Power Calculator",
  "Stamp Duty Calculator",
  "LMI Calculator",
  "Refinance Calculator",
  "Buy Now or Save More Calculator",
  "Equity Calculator",
  "Property Report",
].map((item) => ({ label: item, value: item.toLowerCase().replace(/\s/g, "-") }));

function CalculatorsBlock({ data, setData, actionData }: IPMBlock) {
  return (
    <>
      <div className="title">Calculators Block</div>
      <div className="step-list">
        {[1, 2, 3].map((item: any, index: any) => {
          return (
            <div key={index} className="step-item">
              <FormSelect
                list={availableCalculators}
                defaultValue={data?.[index]}
                label={`Calculator ${index + 1}`}
                onChange={(val) =>
                  setData((prev: any) => {
                    const newPrev = prev || [];
                    newPrev[index] = val.value;
                    return newPrev;
                  })
                }
                disabled={!actionData?.edit}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}

export default CalculatorsBlock;
